
export const sFechaPublicacion = '2026-09-26T23:18:35.6028199-06:00';
export const sVersion = 'vf1.1.609262318';
            